import { AfterViewInit, Component, forwardRef, Host, Input, OnInit, Optional, SkipSelf } from '@angular/core';
import { ControlContainer, FormBuilder, FormGroup, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { FormControlBase } from 'src/app/shared/inputs/form-control-base';

@Component({
  selector: 'app-input-address-postcode',
  templateUrl: './input-address-postcode.component.html',
  styleUrls: ['./input-address-postcode.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputAddressPostcodeComponent),
      multi: true
    }
  ]
})
export class InputAddressPostcodeComponent extends FormControlBase<string> implements OnInit, AfterViewInit {

  @Input() id: string;
  @Input() label: string;
  @Input() groupClass: any;
  @Input() labelClass: any;
  @Input() inputClass: any;
  @Input() isDisabled?: boolean;

  inputGroup: FormGroup;
  private keyInput = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];
  private isChangeVal = false;

  constructor(
    @Optional() @Host() @SkipSelf()
    private cc: ControlContainer,
    private translate: TranslateService,
    private fb: FormBuilder
  ) { super(cc); }

  ngOnInit() {
    this.checkInitialControl();
    this.createForm();
  }

  ngAfterViewInit(): void {
    this.splitValueToForm();
    this.isChangeVal = true;
  }

  protected setValue(val: string) {
    super.setValue(val);
    if (this.value === null) {
      this.clearForm();
    } else {
      this.splitValueToForm();
    }
  }

  keyDown(event, controlName) {
    if (this.checkKeyNumber(event.key)) {
      this.inputGroup.get(controlName).setValue(event.key);
    }
  }

  keyUp(event, controlName, elRefNext) {
    if (this.checkKeyNumber(event.key)) {
      if (elRefNext) {
        elRefNext.focus();
      }
      this.changeValue();
    } else if (!this.checkKeyNumber(event.key)) {
      // remove value others
      this.inputGroup.get(controlName).setValue('');
    }
  }

  changeValue() {
    const data = this.inputGroup.value;
    if (this.inputGroup.valid && this.isChangeVal) {
      this.value = `${ data.inp1 }${ data.inp2 }${ data.inp3 }${ data.inp4 }${ data.inp5 }`;
    }
  }

  checkKeyNumber(key) {
    return this.keyInput.includes(key);
  }

  private createForm() {
    this.inputGroup = this.fb.group({
      'inp1': ['', [Validators.required]],
      'inp2': ['', [Validators.required]],
      'inp3': ['', [Validators.required]],
      'inp4': ['', [Validators.required]],
      'inp5': ['', [Validators.required]]
    });
  }

  private splitValueToForm() {
    setTimeout(() => {
      if (this.value) {
        this.inputGroup.get('inp1').setValue(this.value.substring(0, 1));
        this.inputGroup.get('inp2').setValue(this.value.substring(1, 2));
        this.inputGroup.get('inp3').setValue(this.value.substring(2, 3));
        this.inputGroup.get('inp4').setValue(this.value.substring(3, 4));
        this.inputGroup.get('inp5').setValue(this.value.substring(4, 5));
      }
    });
  }

  private clearForm() {
    this.inputGroup.get('inp1').setValue(null);
    this.inputGroup.get('inp2').setValue(null);
    this.inputGroup.get('inp3').setValue(null);
    this.inputGroup.get('inp4').setValue(null);
    this.inputGroup.get('inp5').setValue(null);
  }
}
